/* eslint-disable */
import { makeStyles } from "@material-ui/core/styles"

export const useStyles = makeStyles({
  snackBarStyle: {
    width: "100%",
    position: "absolute",
    height: "50px",
    top: "0",
  },
  checkIconCustom: {
    fill: '#CC3D3F',
    marginTop:'0.5rem',
  },
  AccountIconCustom: {
    fill:'black',
    marginTop:'0.5rem',
  },
  toastMessage: {
    fontFamily:'Work Sans',
    fontWeight: "normal",
    fontSize: "16px",
    lineHeight: "20px",
    width: "100%",
    "& .MuiAlert-message": {
      width: "100%",
    },
  },
  toastSuccessMessage: {
    width: "100%",
    backgroundColor: '#F4FAF8',
    color:  '#142A39',
    fontFamily:'Work Sans',
    fontWeight: "normal",
    fontSize: "16px",
    lineHeight: "20px",
    letterSpacing: "-0.2px",
    "& .MuiAlert-message": {
      width: "100%",
    },
  },
  message1:{
fontFamily: 'Work Sans',
fontStyle: 'normal',
fontWeight: 'bold',
fontSize: '20px',
lineHeight: '23px',
display: 'flex',
alignItems: 'center',
letterSpacing:'0.25px',
color: '#142A39',
  },
  message2:{
fontFamily: 'Work Sans',
fontStyle: 'normal',
fontWeight: 'normal',
fontSize: '16px',
lineHeight: '20px',
display: 'flex',
alignItems: 'center',
letterSpacing: '-0.2px',
color: '#142A39',
  },
  PrimaryButton :{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    fontSize: '14px',
    width: '100%',
    height: '30px',
    border:'0px',
    background: '#067f6f',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: '4px',
    color: 'white',
    fontStyle: 'normal',
    fontWeight: 'bold',
    lineHeight: '16px',
    textAlign: 'center',
    letterSpacing: '0.75px',
    letterSpacing: "-0.2px",
    "&:hover": {
      backgroundColor: '#067f6f'
    }
  }
});




// WEBPACK FOOTER //
// ./src/views/components/Modal/SnackBarStyles.js